import React, { useCallback } from 'react';

import { CreateLocation } from '@candu-ai/content/create';
import { useAuthentication } from 'commons/hooks';
import { SnapshotState } from 'dashboard/pages/Content/pages/Create/pages/Snapshot';

interface Props {
  onSkip?: () => void;
  setUrl: (url: string) => void;
  setCurrentState: (state: SnapshotState) => void;
}

export const Location = ({ setUrl, setCurrentState, onSkip }: Props) => {
  const { extensionVersion, applicationId } = useAuthentication();

  const onSuccessCreate = useCallback(
    (contentUrl: string) => {
      if (!applicationId) {
        return;
      }

      setUrl(contentUrl);
      setCurrentState('Extension');
    },
    [extensionVersion],
  );

  return <CreateLocation onSuccessCreate={onSuccessCreate} onSkip={onSkip} />;
};
